import produce from 'immer';

export const PROCESS_PARTIAL_REFUND_PENDING = 'partialRefund/process/pending';
export const PROCESS_PARTIAL_REFUND_FULFILLED = 'partialRefund/process/fulfilled';
export const PROCESS_PARTIAL_REFUND_REJECTED = 'partialRefund/process/rejected';
export const PARTIAL_REFUND_RESET = 'partialRefund/reset';
export const PARTIAL_REFUND_SET_AMOUNT = 'partialRefund/amount/set';

// The initial state of the App
export const initialState = {
  loading: false,
  error: null,
  isRefunded: false,
  refundAmount: 0,
};

/* eslint-disable default-case, no-param-reassign */
const partialRefund = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case PROCESS_PARTIAL_REFUND_PENDING:
        draft.loading = true;
        draft.error = false;
        draft.isRefunded = false;
        break;
      case PROCESS_PARTIAL_REFUND_FULFILLED:
        draft.loading = false;
        draft.isRefunded = true;
        break;
      case PROCESS_PARTIAL_REFUND_REJECTED:
        draft.loading = false;
        draft.error = action.error;
        break;
      case PARTIAL_REFUND_RESET:
        return initialState;
      case PARTIAL_REFUND_SET_AMOUNT:
        draft.refundAmount = action.amount;
        break;
      default:
        break;
    }
  });
export default partialRefund;
